import { useState, useEffect } from 'react';
import { api } from '../services/apiClient';

const DEFAULT_SETTINGS = {
  site_name: 'Illustrazioni e Poesia Minuta',
  site_logo_url: 'https://via.placeholder.com/200',
  show_prices: true,
  artist_name: 'Faby',
  artist_bio: 'Illustratrice con passione per le storie visive',
  artist_photo_url: 'https://via.placeholder.com/400',
  contact_email: 'info@fabyart.com',
  contact_phone: '+39 123 456 7890',
  contact_address: 'Italia',
  social_instagram: 'https://instagram.com',
  social_facebook: 'https://facebook.com',
  social_whatsapp: '+39 123 456 7890',
  social_telegram: '',
  social_tiktok: '',
  social_youtube: '',
  about_story: 'La storia dell\'artista e della sua passione',
  about_philosophy: 'La mia filosofia artistica',
  quote_text: 'L\'arte non è ciò che vedi,\nma **ciò che fai vedere** agli altri.',
  quote_author: 'Edgar Degas',
  hero_tagline: 'Arte che abita i tuoi spazi',
  hero_description: 'Un mondo di voci silenziose schive, piccole presenze che abitano il quotidiano e raccontano il nostro modo di camminare nel mondo',
  about_snippet: 'Sono un\'illustratrice appassionata di colore, forma e storytelling visuale. Le mie opere nascono dall\'amore per il dettaglio e dalla ricerca costante di bellezza nel quotidiano. Ogni illustrazione è un invito a vedere il mondo con occhi diversi.',
  cta_title: 'Pronto a scoprire?',
  cta_subtitle: 'Esplora la collezione completa e trova l\'opera perfetta per te.',
  about_philosophy_label: 'La Mia Filosofia',
  testimonials: [],
  testimonials_label: 'Testimonianze e Citazioni',
  contact_cta_title: 'Inizia una conversazione',
  contact_cta_text: 'Che tu sia interessato alle mie opere, voglia una collaborazione o abbia una domanda, contattami pure. Rispondo sempre con entusiasmo.',
  footer_info_title: 'Info & Orari',
  footer_info: 'P.IVA: 04548340753\nLa Cucineria di Sante Le Muse è aperta tutti i giorni sia a pranzo che a cena, colazioni su prenotazione a partire dalle h.10:00, tisane e té con dolci e zuccheri aromatizzati a pomeriggio, agriaperitivi e calici da degustazione.\nGiorno di chiusura: martedì\nGiovedì: KNIT CAFè dalle 16:00 alle 19:00 incontri di gomitoli, uncinetti e maglia per sferruzzare in libertà\nSabato/domenica: laboratori creativi\nDomenica sera solo su prenotazione.\nLo Spaccio Agricolo di Sante Le Muse è aperto sempre, il raccolto si effettua al mattino per cui è preferibile venire in mattinata per avere verdure appena colte.',
};

export function useSettings() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  async function fetchSettings() {
    setLoading(true);
    setError(null);
    try {
      const data = await api.settings.list();

      // Converti array in oggetto e applica defaults
      const settingsObj = { ...DEFAULT_SETTINGS };

      if (data) {
        data.forEach(setting => {
          let value = setting.value;

          // Parse booleani da JSON/string
          if (typeof value === 'string') {
            if (value === 'true') value = true;
            else if (value === 'false') value = false;
          }

          // Parse array JSON (es. testimonials)
          if (setting.key === 'testimonials') {
            if (typeof value === 'string') {
              try { value = JSON.parse(value); } catch { value = []; }
            }
            if (!Array.isArray(value)) value = [];
          }

          settingsObj[setting.key] = value;
        });
      }

      setSettings(settingsObj);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching settings:', err);
      setSettings(DEFAULT_SETTINGS);
    } finally {
      setLoading(false);
    }
  }

  async function updateSetting(key, value) {
    try {
      await api.settings.bulkUpdate([{ key, value }]);

      setSettings({ ...settings, [key]: value });
      return true;
    } catch (err) {
      setError(err.message);
      console.error('Error updating setting:', err);
      return false;
    }
  }

  async function updateMultipleSettings(updates) {
    try {
      const upsertData = Object.entries(updates).map(([key, value]) => ({
        key,
        value,
      }));

      await api.settings.bulkUpdate(upsertData);

      setSettings({ ...settings, ...updates });
      return true;
    } catch (err) {
      setError(err.message);
      console.error('Error updating settings:', err);
      return false;
    }
  }

  return { settings, loading, error, updateSetting, updateMultipleSettings, refetch: fetchSettings };
}
